import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { MapType } from '@/stores/type/map.type'
import { useAuthorizationStore } from '@/stores/authorization'

const { api } = useApi()

const baseUrl = API.MAP.INDEX
const exportShapeFile = API.MAP.EXPORT_SHAPE_FILE

export const useMapStore = defineStore('map', () => {
  // State
  const items = ref<MapType[]>([])
  const currentItem = ref<MapType | undefined>()

  // Authorization Store
  const authorizationStore = useAuthorizationStore()

  // Permissions
  const canAddMap = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: ['add_map']
    })
  })

  const canChangeMap = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: ['change_map']
    })
  })

  const getCurrentMap = computed(() => currentItem.value)

  async function fetchMapDetail(id: number) {
    try {
      const response = await api.service(API.MAP.GET_MAP_DETAIL(id)).get()

      if (!response || response.length === 0) {
        console.warn('Map detail response is empty or undefined.')
        return null
      }

      const mapData: MapType = response[0]
      currentItem.value = mapData
      return mapData
    } catch (error) {
      console.error('Error fetching map detail:', error)
      return null
    }
  }
  const exportLoading = ref(false)
  const downloadShapeFile = async (id: number, type: string) => {
    exportLoading.value = true
    try {
      await api.service(exportShapeFile(id, type)).downloadBlob()
    } catch (e) {
      console.error(e)
    }
    exportLoading.value = false
  }

  function resetAll() {
    items.value = []
    currentItem.value = undefined
  }

  return {
    items,
    currentItem,
    getCurrentMap,
    canAddMap,
    canChangeMap,
    fetchMapDetail,
    resetAll,
    exportLoading,
    downloadShapeFile
  }
})
